export default __webpack_public_path__ + "static/media/cat-selected.d63eab2a.svg";